import React, { Suspense } from 'react'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'
import { SportsIcon } from '@mobi/sports-offering/Components/Common/SportsIcon'
import type { MappedSportWithNationality } from './types'
import { mappedSportsWithNationalFlags } from './Components/index'

export const NationalTeamIcon: React.FC<{
  size: string
  participantId: number
  mappedSportWithNationality: MappedSportWithNationality
  sportName?: KambiSportName
}> = ({ mappedSportWithNationality, participantId, size, sportName }) => {
  const MappedIcon = mappedSportsWithNationalFlags[mappedSportWithNationality]

  if (!MappedIcon) return <SportsIcon size={size} sport={sportName} />

  return (
    <Suspense fallback={null}>
      <MappedIcon size={size} participantId={participantId} sportName={sportName} />
    </Suspense>
  )
}
